import { Button } from '@/components/ui'
import { resetLiffInit } from '@/lib/liff'

export function LiffErrorScreen({
  title = 'เปิดแอปไม่สำเร็จ',
  message,
  onRetry,
}: {
  title?: string
  message: string
  onRetry?: () => void
}) {
  const handleRetry = () => {
    resetLiffInit()
    if (onRetry) {
      onRetry()
    } else {
      window.location.reload()
    }
  }

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-slate-50 px-6 py-10 text-center">
      <div className="max-w-md space-y-4 rounded-2xl border border-red-200 bg-white p-6 shadow-sm">
        <h1 className="text-xl font-bold text-slate-900">{title}</h1>
        <p className="text-base leading-relaxed text-slate-600">{message}</p>
        <ul className="space-y-2 text-left text-sm text-slate-500">
          <li>
            • LIFF Endpoint URL ต้องตรงกับ URL จริง เช่น{' '}
            <code className="text-xs">https://โดเมนของคุณ/liff</code>
          </li>
          <li>• ทดสอบบนมือถือต้องใช้ HTTPS (ngrok / deploy) ไม่ใช่ localhost</li>
          <li>• เปิดสิทธิ์ OpenID Connect ใน LIFF settings</li>
        </ul>
        <Button type="button" className="h-12 w-full text-base" onClick={handleRetry}>
          ลองใหม่
        </Button>
      </div>
    </div>
  )
}
